import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDunkedComponent } from './simple-icons-dunked.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDunkedComponent ],
    exports:      [ SimpleIconsDunkedComponent ],
    bootstrap:    []
})
export class SimpleIconsDunkedModule {}
